const API_URL = process.env.REACT_APP_API_URL;

let apiUrls = {
    information: `${API_URL}/uwb-room/information`
};

export default apiUrls;
